"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedPeerMessage =
/*#__PURE__*/
function (_pb_1$PeerMessage) {
  _inherits(ExtendedPeerMessage, _pb_1$PeerMessage);

  function ExtendedPeerMessage(properties) {
    var _this;

    _classCallCheck(this, ExtendedPeerMessage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedPeerMessage).call(this, properties));
    _this.type = ExtendedPeerMessage.type;
    return _this;
  }

  _createClass(ExtendedPeerMessage, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.property).concat(ExtendedPeerMessage.context, "/").concat(this.sesid).concat(ExtendedPeerMessage.suffix);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.PeerMessage.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedPeerMessage(pb_1.PeerMessage.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedPeerMessage;
}(pb_1.PeerMessage);

ExtendedPeerMessage.type = "PeerMessage";
ExtendedPeerMessage.context = "/peer";
ExtendedPeerMessage.suffix = "/message";
exports.PeerMessage = ExtendedPeerMessage;